<div class="login-container" fxFlex fxLayout="column">
  <div style="float: right; margin-right: 10px; margin-top: 10px">
    <button
      mat-icon-button
      color="primary"
      class="m-r-2"
      style="float: right; margin-top: 10px; margin-right: 10px"
      [ngClass]="showHelpIcon ? 'help-icon-click' : ' help-icon'"
      (click)="ShowHelp()"
      id="myLauncher"
    >
      <img
        [hidden]="hasClass()"
        src="assets/img/Help.png"
        style="height: 24px"
        alt="Help"
      />
      <img
        [hidden]="!hasClass()"
        src="assets/img/Help_Click.png"
        style="height: 24px"
        alt="Help"
      />
    </button>
  </div>

  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    style="flex: 1 1 1e-9px ;"
  >
    <mat-card class="mat-card-sty" data-loader="loginbtn">
      <div class="login-box">
        <div class="login-header">
          <div class="row" style="justify-content: center;">
            <img src="assets/img/logo/Transcriber_Logo.png" alt="acord_logo">
            <!-- <div class="sh-acord-img">
              <img
                src="assets/img/logo/acord-logo.svg"
                alt="acord_logo"
                style="width: 100%"
              />
            </div>
            <div class="sh-line"></div>
            <div class="sh-transcriber-img">
              <img
                src="assets/img/logo/transcriber-logo.svg"
                alt="acord_logo"
                style="width: 100%; height: 48px"
              />
            </div> -->
          </div>
          <div class="sh-login-sub-head">Welcome to Transcriber</div>
        </div>
        <form (ngSubmit)="onFormSubmit(loginForm.value)" class="loginForm"
          [formGroup]="loginForm"
        >
          <div class="login-content" fxLayout="column">
            <div style="display: flex">
              <img src="assets/img/logo/Profile.png" class="sh-profile" />
              <label class="sh-label">Username</label>
            </div>
            <mat-form-field
              class="full-width"
              floatLabel="never"
              appearance="outline"
              style="margin-top: 5px"
            >
              <input
                matInput
                formControlName="email"
                tabindex="1"
                (input)="loginInputChange()"
                name="username"
                required
                class="sh-placeholder"
                placeholder="Enter your username"
              />
              <mat-error class="err-sty"
                *ngIf="
                  !loginForm.get('email').valid &&
                  loginForm.get('email').touched
                "
              >
                {{ getEmailErrorMsg() }}
              </mat-error>
            </mat-form-field>
            <div>
              <div style="display: inline-flex; float: left">
                <img src="assets/img/lock.svg" class="pwd-outline-class" />
                <label class="sh-label">Password</label>
              </div>
              <div class="extra pull-right">
                <a
                  [routerLink]="['/forget-password']"
                  tabindex="3"
                  class="links"
                  >Forgot Password?</a
                >
              </div>
            </div>
            <mat-form-field
              class="full-width password-field"
              floatLabel="never"
              appearance="outline"
              style="margin-bottom: 2px; margin-top: 2px"
            >
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                (input)="loginInputChange()"
                required
                class="sh-placeholder"
                placeholder="Enter your password"
                formControlName="password"
                tabindex="2"
                style="width: 88%"
                name="password"
                required
              />
              <!-- <mat-icon matSuffix (click)="toggleVisibility()"  style="cursor: pointer;">
            {{hide ? 'visibility_off' : 'visibility'}}
          </mat-icon> -->
              <img
                (click)="hide = !hide"
                class="password-eye-icon"
                style="cursor: pointer"
                [src]="
                  hide
                    ? 'assets/img/logo/eye-lock.png'
                    : 'assets/img/logo/eye-show.png'
                "
              />

              <mat-error
                *ngIf="
                  !loginForm.get('password').valid &&
                  loginForm.get('password').touched
                "
              >
                {{ getPasswordErrorMsg() }}
              </mat-error>
            </mat-form-field>
            <div class="login-btn" fxLayout="row" fxLayoutAlign="center center">
              <button mat-raised-button class="mat-primary" [disabled]="!loginForm.valid">Login</button>
              <!-- <button mat-raised-button
               [disabled]="!loginForm.valid &&
                  (loginForm.get('password').touched ||
                    (loginForm.get('username') &&
                      loginForm.get('username').touched))">
                Login
              </button> -->
            </div>

            <div class="login-btn">
              <div
                style="
                  color: #828282;
                  text-align: center !important;
                  align-items: center !important;
                "
              >
                Trouble logging in?
                <a
                  href="https://support.acordsolutions.com/hc/en-us/requests/new"
                  class="links"
                  >Contact Support</a
                >
              </div>
            </div>
            <div style="margin-top: -5px; text-align: center">
              <img
                *ngIf="updateInfo"
                fxFlexAlign="none"
                src="assets/img/Polygon 1.svg"
                class="polygon-class"
                style="height: 2em; width: 2em"
              />
              <div class="passError" *ngIf="updateInfo" fxFlexAlign="none">
                <p>support@acordsolutions.com</p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-card>
  </div>
</div>
